import { useState } from 'react';
import {UseGetTagsResult} from "../types/api";



const useGetTags = (): UseGetTagsResult => {
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [error, setError] = useState<string | null>(null);
    const [data, setData] = useState<any>(null);

    const getTags = async (offset = 0, limit = 100) => {
        setIsLoading(true);
        setError(null);

        try {
            const apiUrl = process.env.REACT_APP_API_BASE || '/api';

            const response = await fetch(`${apiUrl}/tags/?offset=${offset}&limit=${limit}`, {
                method: 'GET',
            });

            if (!response.ok) {
                const errorText = await response.text();
                throw new Error(`HTTP error! status: ${response.status}, message: ${errorText}`);
            }

            const result = await response.json();
            setData(result);
            return result;
        } catch (err) {
            const errorMessage = err instanceof Error ? err.message : 'Неизвестная ошибка';
            setError(errorMessage);
            throw err;
        } finally {
            setIsLoading(false);
        }
    };

    return { getTags, isLoading, error, data };
};

export default useGetTags;